import store from "./state/index";
import router from "./router"
import { createApp, h } from 'vue'
import App from './app.vue'
import Toaster from "@meforma/vue-toaster";
import { clientLogger } from './utils/clientLogger';
import { useJQuery } from "./utils/injectJQuery";
import { initAppInsights } from "./utils/telemetry";

// Required by bootstrap
window.jQuery = useJQuery();

try {
    require("bootstrap");
} catch (err) {
    console.error("Error bootstraping jquery", err);
}


window.clientLogger = clientLogger;

if (window.__ENV__.APPLICATIONINSIGHTS_CONNECTION_STRING) {
    const ai = initAppInsights({
        config: {
            connectionString: window.__ENV__.APPLICATIONINSIGHTS_CONNECTION_STRING,
            enableAutoRouteTracking: true,
            enableCorsCorrelation: true,
            enableAjaxErrorStatusText: true,
            distributedTracingMode: 2,
        }
    });

    ai.addTelemetryInitializer((envelope) => {
        envelope.tags = envelope.tags || {};
        envelope.tags["ai.cloud.role"] = window.__ENV__.OTEL_SERVICE_NAME || "mattekartlegging-frontend";
        envelope.tags["ai.cloud.environment"] = window.__ENV__.OTEL_ENVIRONMENT || "development";
    });
}

const app = createApp({
    render: () => h(App),
});

(
    app
    .use(store)
    .use(Toaster)
    .use(router)
    .provide('__toast', () => app.config.globalProperties.$toast)
    .mount("#app")
);
